import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dash-board.module').then((m) => m.DashBoardModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'medication-master',
    loadChildren: () =>
      import('./medication-master/medication-master.module').then(
        (m) => m.MedicationMasterModule
      ),
  },
  {
    path: 'examination-master',
    loadChildren: () =>
      import('./examination-master/examination-master.module').then(
        (m) => m.ExaminationMasterModule
      ),
  },
  {
    path: 'intervention-master',
    loadChildren: () =>
      import('./intervention-master/intervention-master.module').then(
        (m) => m.InterventionMasterModule
      ),
  },
  { path: '**', redirectTo: 'dashboard' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
